module.exports = __webpack_public_path__ + "img/base.1113dfab.png";